<template>
  <b-modal id="modal-add-server" size="md" no-close-on-backdrop>
    <!-- custom modal title -->
    <template #modal-title>
      <div class="d-flex align-items-center">
        <i class="bi bi-server mr-05" />
        <span class="fs-18">Tambah Server Baru</span>
      </div>
    </template>
    <!-- form container -->
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0">
      <b-card-body>
        <validation-observer ref="serverRules">
          <b-form>
            <!-- nama server -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Nama Server"
                rules="required"
              >
                <label for="nama-server"
                  >Nama Server <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="ServerIcon" />
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="server_data.name"
                    id="nama-server"
                    placeholder="Masukkan Nama Server"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
                <small
                  v-if="error_message"
                  class="text-danger"
                  style="font-size: 10px"
                >
                  {{ error_message || "" }}
                </small>
              </validation-provider>
            </b-form-group>
            <!-- URL Grafana -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="URL-Grafana"
                rules="required"
              >
                <label for="URL-Grafana">
                  URL Grafana <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LinkIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="server_data.grafana_url"
                    id="username"
                    placeholder="Masukkan URL Grafana"
                    :focus="error_message"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <!-- custom modal footer -->
    <template #modal-footer>
      <!-- button batal -->
      <b-button
        variant="outline-danger"
        size="sm"
        class="float-right mr-05"
        @click="canceladdServer"
      >
        Batal
      </b-button>
      <!-- button simpan -->
      <b-button
        variant="outline-info"
        size="sm"
        class="float-right"
        @click.prevent="addNewServer"
      >
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal,
  VBModal,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BAlert,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "addServer",
  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BAlert,
    "loader-component": floating_loader,
  },
  data() {
    return {
      is_loading: false,
      error_message: null,
      server_data: {
        nama: null,
        grafana_url: null,
      },
      //   validation
      required,
    };
  },
  created() {},
  methods: {
    addNewServer() {
      this.$refs.serverRules.validate().then((success) => {
        if (success) {
          this.is_loading = true;
          this.error_message = null;
          let api = process.env.VUE_APP_API_URL + "server/add";
          let params = {
            name: this.server_data.name,
            grafana_url: this.server_data.grafana_url,
          };
          useJwt.axiosIns
            .post(api, { data: params })
            .then((res) => {
              this.server_data = {
                name: null,
                grafana_url: null,
              };
              this.$bvModal.hide("modal-add-server");
              this.$parent.getData();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Berhasil",
                  icon: "CheckCircleIcon",
                  variant: "success",
                  text: `${res.data.message || "Data Telah Ditambahkan!"}`,
                },
              });
            })
            .catch((err) => {
              this.error_message =
                err.response.data.detail.message ||
                "Terjadi Kesalahan Pada Sistem!";
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    canceladdServer() {
      this.server_data = {
        name: null,
        grafana_url: null,
      };
      this.$bvModal.hide("modal-add-server");
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>
<style>
.modal-title {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 20px !important;
  font-weight: bold;
}
</style>
